module.exports = __webpack_public_path__ + "img/pdf.72db6ef.svg";